import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(public)/privacy-policy/page.tsx");
